import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Close from '@mui/icons-material/Close';
import { Form, Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { MerchantTitle } from 'app/MerchantTitle';
import { SignUpDOBData } from 'components/user/model/User';
import { MuiAppBar } from 'lib/appbar/MuiAppBar';
import { TextFormField } from 'lib/form/TextFormField';
import { LoadingButton } from 'ui/LoadingButton';

const PREFIX = 'AgeVerification';

const classes = {
    button: `${PREFIX}button`
};

const StyledGrid = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
    [`& .${classes.button}`]: {
        height: '48px',
        fontSize: '1.2em'
    }
}));

interface IAgeVerificationProps {
    onBack: () => void;
    initialValues: SignUpDOBData;
    birthDateValidation: Yup.ObjectSchema<{ birthDate: string }>;
    onSubmit: (dobData: SignUpDOBData, formikHelpers: FormikHelpers<SignUpDOBData>) => void;
    error?: string;
}

export const AgeVerification: React.FC<React.PropsWithChildren<IAgeVerificationProps>> = ({
    onBack,
    initialValues,
    birthDateValidation,
    onSubmit,
    error
}) => {
    const { t } = useTranslation();

    return (
        <>
            <MerchantTitle title={t('ONBOARDING_DOB_TITLE')} />
            <MuiAppBar title={t('ONBOARDING_DOB_TITLE')} onBack={onBack} disabledMenu icon={Close} />
            <Formik initialValues={initialValues} validationSchema={birthDateValidation} onSubmit={onSubmit}>
                {({ submitForm, isValid, values: { birthDate }, isSubmitting }) => (
                    <Form>
                        <StyledGrid container spacing={2}>
                            <Grid size={12}>
                                <Typography>{t('ONBOARDING_DOB_MESSAGE')}</Typography>
                            </Grid>
                            <Grid size={12}>
                                <TextFormField
                                    name="birthDate"
                                    autoFocus
                                    type="date"
                                    label={t('USER_DETAILS_BIRTHDATE_TITLE')}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            {!!error && (
                                <Grid size={12}>
                                    <Typography color="error">{error}</Typography>
                                </Grid>
                            )}
                            <Grid size={12}>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    disabled={!isValid || isSubmitting || !birthDate}
                                    fullWidth
                                    onClick={submitForm}
                                    className={classes.button}
                                    loading={isSubmitting}
                                >
                                    {t('BUTTON_SUBMIT')}
                                </LoadingButton>
                            </Grid>
                        </StyledGrid>
                    </Form>
                )}
            </Formik>
        </>
    );
};
